import { render, staticRenderFns } from "./riderWisePerformanceReport.vue?vue&type=template&id=7b46dd90&"
import script from "./riderWisePerformanceReport.vue?vue&type=script&lang=js&"
export * from "./riderWisePerformanceReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports